module.exports = __webpack_public_path__ + "static/media/lameirao.6aa888ab.png";